//in the app module everthing is public, so we don't have to use 'app-src/private' it is not necesary
//ioc
export * from './ioc/ioc.keys.class';
export * from './ioc/implementations/app-ioc-container/app-ioc-container.class';
export * from './ioc/implementations/app-ioc-container/app-ioc-container.interface';

export * from './ioc/implementations/app-settings/app-settings.interface';
export * from './ioc/implementations/app-settings/app-settings.class';

//components
export * from './app.component';
export * from './components/page-components/home/home.page';

//sidebar modules
export * from './sidebar-modules/clear-local-storage-sidebar.module';
